import { useEffect } from "react";
import { useDispatch, useStore } from "../store";
import { clearMerativeLinkWithToken } from "../store/actions";

export default function useMerativeLink() {
  const dispatch = useDispatch();
  const { merativeLinkWithToken } = useStore();

  useEffect(() => {
    if (merativeLinkWithToken) {
      window.open(merativeLinkWithToken, "_blank");
      clearMerativeLinkWithToken(dispatch);
    }
  }, [merativeLinkWithToken, dispatch]);
}
